import { ReactNode, useContext } from "react"
import ad from "../../_asset/banner/ad.png"
import gs from "../../_asset/banner/gs.png"
import { lobbyModalContext } from "../provider/lobby_modal_provider"
import { sexyVendor } from "../../data/gameData_casino"
import { actionContext } from "../../apps/page"

export default function EventAdLayout({ children }: { children: ReactNode }) {
    const {User,SetLoginPop} = useContext(actionContext)
    const {SetLobbyShow, SetVendorInfo, SetType} = useContext(lobbyModalContext)
    
    function sexyLink(){
        if(User.is_authenticated){
            if(sexyVendor){
                SetLobbyShow()
                SetVendorInfo(sexyVendor)
                SetType('casino')
            }
        }else{
            SetLoginPop()
        }

    }
    return (
        <>
            {/* <div className="ad-left">
                <img src={ad} className="ad" onClick={e=> sexyLink()} />
                <img src={gs} className="gs" />
            </div>
            <div className="ad-right">
                <img src={ad} className="ad" onClick={e=> sexyLink()} />
                <img src={gs} className="gs" />
            </div> */}
            {children}
        </>
    )
}